import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { TaskBoardsList } from '@/features/task-boards'
import { requireActiveSubscription } from '@/lib/middleware'

const boardsSearchSchema = z.object({
  search: z.string().optional().catch(''),
  entityType: z.string().optional().catch(''),
  entityId: z.string().optional().catch(''),
  visibility: z.string().optional().catch(''),
  showClosed: z.boolean().optional().catch(false),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/tasks/boards/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: TaskBoardsList,
  validateSearch: boardsSearchSchema,
})
